export const getLinkTarget = (path: string) => {
  if (!path) {
    return '_self'
  }

  return path.startsWith('https://') ? '_blank' : '_self'
}
